import { render } from "./search-filter-requisitions.vue?vue&type=template&id=618b0bad&scoped=true"
import script from "./search-filter-requisitions.vue?vue&type=script&lang=js"
export * from "./search-filter-requisitions.vue?vue&type=script&lang=js"

import "./search-filter-requisitions.vue?vue&type=style&index=0&id=618b0bad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618b0bad"]])

export default __exports__